const TmpL007 = (page, section) => {
  const media = [];
  const eMentors = [];
  const modifiedPage = {
    ...page
  };

  page.content.core.forEach((question, index) => {
    // remove any found audio time stamps if NOT type 3 aka Audio Prompt
    if (question.type_id !== 3) {
      delete modifiedPage.content.core[index].start_minute;
      delete modifiedPage.content.core[index].start_second;
      delete modifiedPage.content.core[index].end_minute;
      delete modifiedPage.content.core[index].end_second;
    }

    // combine the question and answer into a single object
    modifiedPage.content.core[index].incorrect_feedback = [
      question.incorrect_feedback_1,
      question.incorrect_feedback_2,
      question.incorrect_feedback_3
    ];
    // remove the incoreect responses from the modified page data
    delete modifiedPage.content.core[index].incorrect_feedback_1;
    delete modifiedPage.content.core[index].incorrect_feedback_2;
    delete modifiedPage.content.core[index].incorrect_feedback_3;
    // remove multi_select, IMI is able to look at lures to figure that data out
    delete modifiedPage.content.core[index].multi_select;
  });

  // update the the ementor content with the page id
  if (page.content.eMentor) {
    page.content.eMentor.forEach((mentor) => {
      const eMentor = {
        ...mentor,
        page: page.id
      };
      eMentors.push(eMentor);
    });
  }

  // Extract metadata separately
  const metadata = {
    media: [],
    images: [],
    materials: [],
    eMentor: eMentors,
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpL007;
